/**
 * riderWorkStatus 전용 날짜 유틸 (공유 dateUtils에 없는 함수만 유지)
 * formatDateToISO, removeDateHyphens → @/shared/utils/dateUtils 사용
 */

/**
 * Date 객체를 YYYYMMDD 형식 문자열로 변환 (스토리지/필터 저장용)
 */
export const formatDateToStorage = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
};

/**
 * YYYY-MM-DD 형식의 날짜를 MM/DD 형식으로 변환 (테이블 헤더 표시용)
 */
export const formatDateToMonthDay = (dateStr: string): string => {
    if (!dateStr) return '';
    const parts = dateStr.split('-');
    if (parts.length === 3) {
        return `${parts[1]}/${parts[2]}`;
    }
    return dateStr;
};
